import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('$billingAccounts', BillingAccountsObjectFactory);

/* @ngInject */
function BillingAccountsObjectFactory($bringozFactory: $bringozFactory,
                                      BillingAccountsAPI: BringozApi,
                                      BillingAccounts_DS: DataStoreConfig,
                                      BillingAccounts_PN: PushNotificationsConfig) {
  function $billingAccounts(id: string) {
    return $bringozFactory(id, BillingAccountsAPI, BillingAccounts_DS, BillingAccounts_PN)
  }

  return $billingAccounts;
}
